import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { fetchAccountDetails } from '../../../actions/adminActions';

import { saveTeam, activeTeam, deleteTeam } from '../../../actions/teamActions';

import Users from '../UserList/Users';

class CreateTeam extends Component {
  static propTypes = {
    handleBack: PropTypes.func,
    fetchAccountDetails: PropTypes.func,
    updatedActivePage: PropTypes.func,
    selectedTeam: PropTypes.instanceOf(Object),
    accountDetail: PropTypes.instanceOf(Object),
    teamUsers: PropTypes.instanceOf(Object),
    hasAccess: PropTypes.bool,
  };

  static defaultProps = {
    selectedTeam: {},
    accountDetail: {},
    teamUsers: [],
    hasAccess: 0,
  };

  state = {
    team: {},
    allUsers: [],
    activeUsers: [],
    clearUsers: false,
    allFeatures: [],
    hasError: false,
    successMessage: '',
    serviceError: '',
  };

  UNSAFE_componentWillMount() {
    this.updateInitialValues();
  }

  onInputChange = (e, type) => {
    const team = _.cloneDeep(this.state.team);
    let value = e.target.value;
    if (value.trim().length === 0) {
      value = '';
    }
    team[type] = value;
    this.setState({ team });
  };

  updateSelectedItems = activeUsers => {
    this.setState({ activeUsers });
  };

  updateInitialValues = () => {
    const { accountDetail, teamUsers } = this.props;
    const activeUsers = [];
    if (!_.isEmpty(teamUsers)) {
      teamUsers.map(user => {
        activeUsers.push(user);
        return false;
      });
    }

    this.setState({
      activeUsers: this.props.selectedTeam.name ? activeUsers : [],
      team: this.props.selectedTeam,
      allUsers: accountDetail.users,
      allFeatures: accountDetail.features,
    });
  };

  handleReset = () => {
    this.setState(
      {
        clearUsers: false,
        hasError: false,
        serviceError: '',
      },
      () => {
        this.updateInitialValues();
      }
    );
  };

  handleSave = () => {
    const { activeUsers, team } = this.state;
    const { accountDetail } = this.props;
    const { name = '', description = '', id = '' } = team;
    const request = {
      accountId: accountDetail.accountId,
      name: name.trim(),
      description: description ? description.trim() : '',
      id,
      users: activeUsers,
    };
    let activeStatus = 'N';
    if (this.props.selectedTeam.name) {
      activeStatus = this.props.selectedTeam.activeStatus;
    } else {
      activeStatus = 'Y';
    }

    let isEditUser = false;
    if (id) {
      isEditUser = true;
    }

    if (name && activeStatus === 'Y') {
      this.setState(
        { hasError: false, serviceError: '', successMessage: '' },
        () => {
          saveTeam(request).then(response => {
            if (response.data === 'SUCCESS') {
              this.setState(
                { successMessage: 'Team saved successfully' },
                () => {
                  if (this.state.successMessage) {
                    setTimeout(() => {
                      this.props.fetchAccountDetails(accountDetail);
                      this.props.updatedActivePage({ activeTeamPage: 'TEAM' });
                    }, 2000);
                  }
                }
              );
            }
            if (response.error) {
              this.setState({ serviceError: response.error, hasError: true });
            }
          });
        }
      );
    } else if (activeStatus === 'N') {
      this.setState({
        serviceError: 'Please activate the team.',
        hasError: true,
      });
    } else {
      this.setState({ hasError: true });
    }
  };

  handleDeleteTeam = () => {
    const { accountDetail } = this.props;
    const teamId = this.state.team.id;
    this.setState(
      { hasError: false, serviceError: '', successMessage: '' },
      () => {
        deleteTeam(teamId).then(response => {
          if (response.data === 'SUCCESS') {
            this.setState(
              { successMessage: 'Team deleted successfully' },
              () => {
                if (this.state.successMessage) {
                  setTimeout(() => {
                    this.props.fetchAccountDetails(accountDetail);
                    this.props.updatedActivePage({ activeTeamPage: 'TEAM' });
                  }, 2000);
                }
              }
            );
          }
          if (response.error) {
            this.setState({ serviceError: response.error, hasError: true });
          }
        });
      }
    );
  };

  handleActivateTeam = () => {
    const { accountDetail } = this.props;
    const teamId = this.state.team.id;
    this.setState(
      { hasError: false, serviceError: '', successMessage: '' },
      () => {
        activeTeam(teamId).then(response => {
          if (response.data === 'SUCCESS') {
            this.setState(
              { successMessage: 'Team activated successfully' },
              () => {
                if (this.state.successMessage) {
                  setTimeout(() => {
                    this.props.fetchAccountDetails(accountDetail);
                    this.props.updatedActivePage({ activeTeamPage: 'TEAM' });
                  }, 2000);
                }
              }
            );
          }
          if (response.error) {
            this.setState({ serviceError: response.error, hasError: true });
          }
        });
      }
    );
  };

  render() {
    const {
      team,
      allUsers,
      activeUsers,
      allFeatures,
      hasError,
      successMessage,
      serviceError,
    } = this.state;
    const { name = '', description = '', activeStatus = 'N', id = '' } = team;
    const { teamUsers } = this.props;

    const { selectedTeam } = this.props;
    const selectdTeamUserObj = [];
    _.map(activeUsers, user => {
      _.map(allUsers, item => {
        if (user.userId === item.userId) {
          selectdTeamUserObj.push(user);
        }
      });
    });

    const sortedUsers = _.isEmpty(selectdTeamUserObj)
      ? []
      : _.sortBy(selectdTeamUserObj, o => o.firstName);

    let sortedUSerIds = [];
    let teamUsersIds = [];

    if (!_.isEmpty(sortedUsers)) {
      sortedUSerIds = sortedUsers.map(item => item.userId);
    }
    if (!_.isEmpty(teamUsers)) {
      teamUsersIds = teamUsers.map(item => item.userId);
    }

    const addedNewUsers = !_.isEqual(sortedUSerIds.sort(), teamUsersIds.sort());
    const hasNameUpdate = selectedTeam.name !== name;
    const hasDescriptionUpdate = selectedTeam.description !== description;

    const hasUpdated = addedNewUsers || hasNameUpdate || hasDescriptionUpdate;

    let errorMessage = '';

    // if (!id && hasError && _.isEmpty(activeUsers)) {
    //   errorMessage = 'Atleast one user should assign to the team.';
    // }
    // if (hasError) {
    //   errorMessage = 'Team Description is required field.';
    // }

    if (hasError && !name) {
      errorMessage = 'Team name is required field';
    }

    if (serviceError) {
      errorMessage = serviceError;
    }

    let isDisabled = true;
    if (hasUpdated && this.props.hasAccess) {
      isDisabled = false;
    }

    let renderActionButton = '';
    if (this.props.selectedTeam.id) {
      if (activeStatus === 'Y') {
        renderActionButton = (
          <button
            onClick={this.handleDeleteTeam}
            className="btn deleteButton"
            disabled={!this.props.hasAccess}
          >
            <span>Delete</span>
          </button>
        );
      } else {
        renderActionButton = (
          <button
            onClick={this.handleActivateTeam}
            className="btn activateButton"
          >
            <span>Activate</span>
          </button>
        );
      }
    }
    return (
      <div className="accounts-role">
        {errorMessage && <span className="error-message">{errorMessage}</span>}
        {successMessage && (
          <span className="success-message">{successMessage}</span>
        )}
        <div className="accounts-details-card-header">
          <div className="role-title">
            <h4>
              {this.props.selectedTeam.name ? 'View/Edit Team' : 'Create Team'}
            </h4>
          </div>
          <div className="adduser-card-actions roles-actions">
            <button
              onClick={this.handleSave}
              className="btn saveButton"
              disabled={isDisabled}
            >
              <span>Save &amp; Apply</span>
            </button>
            <button
              className="btn resetButton"
              disabled={isDisabled}
              onClick={this.handleReset}
            >
              Reset
            </button>
            <button
              onClick={this.props.handleBack}
              className="btn cancelButton"
            >
              <span>Cancel</span>
            </button>
            {renderActionButton}
          </div>
        </div>
        <div className="accounts-role--details custom-account-block">
          <div className="accounts-role--header" style={{ borderBottom: 0 }}>
            <div className="accounts-role-input-col">
              <div className="accounts-role--label">Name: </div>
              <div className="accounts-role--name">
                <input
                  className={`form-control ${
                    hasError && !name ? 'has-error' : ' '
                  }`}
                  type="text"
                  value={name}
                  onChange={e => this.onInputChange(e, 'name')}
                  placeholder="Enter team name..."
                />
              </div>
            </div>
            <div className="accounts-role-input-col">
              <div className="accounts-role--label">Description: </div>
              <div className="accounts-role--name">
                <input
                  className="form-control"
                  type="text"
                  value={description}
                  onChange={e => this.onInputChange(e, 'description')}
                  placeholder="Enter team description..."
                />
              </div>
            </div>
          </div>
          <div className="accounts-role-users--wrapper team">
            <div className="accounts-role-users">
              <h4>Select User(s)</h4>
              <Users
                users={allUsers}
                activeUsers={activeUsers}
                updateSelectedItems={this.updateSelectedItems}
                clearUsers={this.state.clearUsers}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAccountDetails: bindActionCreators(fetchAccountDetails, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(CreateTeam);
